export const AUTH_INPUT_HEIGHT = 44;

export const authLabelSx = {
  display: "block",
  fontSize: 13,
  fontWeight: 600,
  color: "#374151",
  mb: 0.7,
  letterSpacing: 0,
};

export const authCardSx = {
  background: "#fff",
  borderRadius: "12px",
  border: "1px solid #E5E7EB",
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04), 0 12px 32px rgba(15, 23, 42, 0.06)",
  p: { xs: 3, sm: 4 },
};

export const authButtonSx = {
  mt: 0.5,
  height: AUTH_INPUT_HEIGHT,
  py: 0,
  fontSize: 15,
  fontWeight: 600,
  letterSpacing: 0,
  textTransform: "none",
  borderRadius: "8px",
  background: "var(--brand-primary)",
  boxShadow: "none",
  "&:hover": { background: "var(--brand-primary-hover)", boxShadow: "none" },
  "&:disabled": { background: "var(--brand-primary-soft-active)", color: "#fff" },
};

export const authSegmentSx = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 0.5,
  mb: 2.5,
  p: "4px",
  borderRadius: "10px",
  background: "#F3F4F6",
  border: "1px solid #E5E7EB",
};

export function authSegmentBtnSx(active) {
  return {
    py: 1,
    minHeight: 38,
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: 14,
    letterSpacing: 0,
    color: active ? "#fff" : "#374151",
    background: active ? "var(--brand-primary)" : "transparent",
    boxShadow: "none",
    "&:hover": { background: active ? "var(--brand-primary-hover)" : "#fff" },
  };
}
